import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const R4DomAmaMain = lazy(
  () => import('../r4draft/domesticAmateur/R4DomAmaMain')
);
const R4Schools = lazy(
  () => import('../r4draft/domesticAmateur/schools/R4Schools')
);
const R4School = lazy(
  () => import('../r4draft/domesticAmateur/schools/R4School')
);

export default [
  {
    id: NavConfig.groupConfigs.RULE_4_DOM_AMA.id,
    path: NavConfig.groupConfigs.RULE_4_DOM_AMA.to,
    element: (
      <R4DomAmaMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </R4DomAmaMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.R4_ADMIN.to} />,
      },
      {
        id: NavConfig.linkConfigs.R4_SCHOOLS.id,
        path: NavConfig.linkConfigs.R4_SCHOOLS.to,
        element: <R4Schools />,
      },
    ],
  },
  {
    id: NavConfig.linkConfigs.R4_SCHOOL.id,
    path: NavConfig.linkConfigs.R4_SCHOOL.to,
    element: <R4School />,
  },
];
